import React from 'react'

const AnalyticsDateFilterSkeleton = () => {
    return (
        <div className="w-full flex flex-row items-center px-[30px] py-[20px]">
            <div className="w-full flex flex-row items-center justify-between">
                <div className="analytics-date-range flex flex-row items-center">
                    <div className="h-5 w-[120px] bg-lightBG rounded opacity-50 mr-6"></div>
                    <div className="h-10 w-[340px] bg-lightBG rounded-full opacity-50"></div>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsDateFilterSkeleton
